import { render } from "./ScriptInfo.vue?vue&type=template&id=855789d8"
import script from "./ScriptInfo.vue?vue&type=script&lang=js"
export * from "./ScriptInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__